// eslint-disable-next-line
import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import ModalsVentasPage from "./modals.ventas.page";
import MakeViewAlmacenGral from "./MakeViewAlmacenGral";
import Select from 'react-select'
import moment from 'moment'
import { faPlus,faEye,faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from 'react-modal'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
const formatter = buildFormatter(spanishStrings)

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class AltasModulePage extends Component {
  constructor(props) {
    super(props);
    this.keyBindingBtns = this.keyBindingBtns.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this)

    this.state = {
      mostrarMisVentas: 2, //Def: 3
      arrStock: [],
      arrStockGral: [], //Almacen general de productos
      dateAlmacen: moment().format('YYYY-MM-DD'),

      valSearch: '',
      valSearchByFullCode: '',

      id_sucursal_option: this.props.initState.id_sucursal,
      id_sucursal_destino: this.props.initState.id_sucursal,
      valSeach: '',

      arrayListResults: [],
      indexItemByKeyboard: 0,


    }
  }

  componentDidMount() {
    this.getStockAlmacen()
    document.addEventListener("keydown", this.keyBindingBtns, false);

    this.getCombosAlmacenGral()
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyBindingBtns, false);
  }

  keyBindingBtns(event) {
    const { indexItemByKeyboard, arrayListResults, isOpenSearchProducto, isOpenSearchProductoByEntradaGral, isOpenPagarCompra, } = this.props.subState
    const { renderView } = this.props.initState

    if(renderView !== 'altas') {
      return false;
    }
    // [productos] F2  -> 113
    // [abajo]     ⬇  -> 40
    // [arriba]    ⬆  -> 38
    // [enter]     ⤵  -> 13

    if(event.keyCode === 113) {

      this.setBindProductos()
    } else if(event.keyCode === 40) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard < (arrayListResults.length - 1) ? (indexItemByKeyboard + 1) : indexItemByKeyboard })
    } else if(event.keyCode === 38) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard > 0 ? (indexItemByKeyboard - 1) : indexItemByKeyboard })
    } else if(event.keyCode === 13) {
      
      if(isOpenSearchProducto && arrayListResults.length > 0) {

        this.props.subSetState({ indexItemByKeyboard: 0, })
      } else if(isOpenSearchProducto) {

        // this.selectItemProductFromProcesos(indexItemByKeyboard)
        this.selectItemProduct(indexItemByKeyboard)
        this.setState({ indexItemByKeyboard: 0, })
      } else if(isOpenPagarCompra) {
        // this.onRegisterNewVenta()
      } else {
        this.inputSearchByCode.focus();
      }
    } else if(event.keyCode === 9) {
      if( document.activeElement.id === 'ws-input-search-code' ) {
        this.onSearchProductoByCode()
        event.preventDefault()
      }
    }
  }


  render() {
    const { mostrarMisVentas, isOpenSearchProducto, valSearch, arrayListResults, indexItemByKeyboard, } = this.state

    let { arrListVenta } = this.props.subState

    return (
      <Row style={{ padding: 10, background: '#fff', margin: 0, }}>
        <Col>
          <div className="form-check form-check-inline">
            <p
              className={'btn btn-sm altasModule__btnAction'}
              onClick={() =>{ this.setState({ mostrarMisVentas: 2 }) }}
            ><FontAwesomeIcon icon={faPlus} /> Nuevo envío a sucursal</p>
          </div>
          <div className="form-check form-check-inline">
            <p
              className={'btn btn-sm altasModule__btnAction'}
              onClick={() =>{ this.setState({ mostrarMisVentas: 3 }); this.getCombosAlmacenGral() }}
            ><FontAwesomeIcon icon={faLayerGroup} /> Ver envíos pendientes</p>
          </div>
          
          <div className="form-check form-check-inline">
            <p

              className={'btn btn-sm altasModule__btnAction'}
              onClick={() =>{ this.setState({ mostrarMisVentas: 1 }) }}
            ><FontAwesomeIcon icon={faEye} /> Ver almacenes</p>
          </div>
          <div className="form-check form-check-inline">
            <p

              className={'btn btn-sm altasModule__btnAction'}
              onClick={() =>{ this.props.initsetState({ viewApp: 'control_inventarios', isAlmacenesAccess: true, }) }}
            ><FontAwesomeIcon icon={faEye} /> Ver control inventarios</p>
          </div>

        </Col>
        
        { this.state.mostrarMisVentas === 1 ? this.makeViewVentas() : null }
        { this.state.mostrarMisVentas === 2 ? this.makeViewAlmacen() : null }
        { this.state.mostrarMisVentas === 3 || this.state.mostrarMisVentas === 4 ?
          <MakeViewAlmacenGral
            subState={ this.props.subState } subSetState={ (param) => this.props.subSetState(param) }
            initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) }
            altasState={ this.state } altassetState={ (param) => this.setState(param) }
          />
          : null }
        
        <ModalsVentasPage
          subState={ this.props.subState } subSetState={ (param) => this.props.subSetState(param) }
          initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) }
          selectItemProduct={ (e) => this.selectItemProduct(e) }
          selectItemProductFromProcesos={ (e) => this.selectItemProductFromProcesos(e) }
        />

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={isOpenSearchProducto}
          onRequestClose={() => { this.setState({isOpenSearchProducto: false}) }}
          style={customStyles}
          contentLabel="Seleccionar un producto"
          >
          <div className="modalBody__operador">
            <Row className="modalBody__corte"> 
              <Col>
                <h4 style={{ margin: 0, }}>Seleccionar un producto</h4>
                <input
                  type="text"
                  placeholder="Ingresa el nombre del producto..."
                  value={valSearch}
                  onChange={(e) => this.onViewProduct(e.target.value) } 
                  ref={(input) => { this.inputSearchProducto = input; }}
                  style={{ margin: '20px auto', }}
                />

                <Row>
                  <Col xs={'5'}>
                    <b>Nombre</b>
                  </Col>
                  <Col xs={'2'}>
                    <b>Categoría</b>
                  </Col>
                  <Col xs={'2'}>
                    <b>P. Venta</b>
                  </Col>
                  <Col xs={'3'}>
                    <b>Fecha actualizado</b>
                  </Col>
                </Row>
                {
                  arrayListResults.map((t,e) => (
                    <div key={`ws_list_compra_${e}`}>
                      <Row
                        onClick={ () => { this.selectItemProduct(e) } }
                        style={{ width: '100%', margin: '0 auto', marginTop: 5, }}
                        className={`regVentaPage__content ${e === indexItemByKeyboard ? 'regVentaPage__content__active' : null}`}
                      >
                        <div className="regVentaPage__separator"></div>
                        <Col xs={'5'} className="regVentaPage__listProduct">
                          <p style={{ color: '#333', margin: 0, }}>{t.nombre}</p>
                        </Col>
                        <Col xs={'2'} className="regVentaPage__listPrices">
                          <p style={{ color: '#333', margin: 0, }}>{t.categoria}</p>
                        </Col>
                        <Col xs={'2'} className="regVentaPage__listPrices">
                          <p style={{ color: '#333', margin: 0, fontWeight: '800' }}>${this.number_format(t.precio_venta, 2)}</p>
                        </Col>
                        <Col xs={'3'} className="regVentaPage__listPrices">
                          <TimeAgo
                            style={{ color: (t.update == 1 ? '#16a085' : '#444'), }}
                            className="__listViewPending_time" date={t.fecha_cambio_costo} formatter={formatter}
                          />
                          {
                            t.update == 0
                            ? <p style={{ fontSize: '.8rem', }}>El costo aún no ha sido actualizado</p>
                            : null
                          }
                        </Col>
                      </Row>
                    </div>
                  ))
                }

              </Col>
            </Row>
          </div>
        </Modal>

      </Row>
    )
  }

  makeViewAlmacen() {
    const { fecha_entrada_almacen, serie_almacen, referencia_almacen, noDocEntradaAlmacen, } = this.props.subState

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Envío a sucursales</p>
              <hr />
            </Row>

            <Row>
              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Fecha</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={"date"}
                      value={fecha_entrada_almacen}
                      onChange={(event) => {this.props.subSetState({fecha_entrada_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Sucursal de destino</p>
                  </Col>
                  <Col xs={'7'}>
                    <Select
                      placeholder="ELIGE UNA SUCURSAL"
                      options={this.props.subState.arrSucursales}
                      onChange={(val) => {
                        if(val.id_sucursal === 'almacen_gral') {
                          alert('Error, el almacen general no puede ser elegido en esta sección. Para registrar una entrada ve a "Pedidos Sugeridos -> Registrar entrada al almacén"')
                          return false
                        }
                        this.setState({id_sucursal_destino: val.id_sucursal})
                      }}
                      styles={customStylesOption}
                    />
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Serie</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una serie'}
                      value={serie_almacen}
                      onChange={ (event) => { this.props.subSetState({serie_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Referencia</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una referencia'}
                      value={referencia_almacen}
                      onChange={ (event) => { this.props.subSetState({referencia_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={'3'}>
                <b>Nombre</b>
              </Col>
              <Col xs={'3'}>
                <b>Cantidad</b>
              </Col>
              <Col xs={'3'}>
                <b>Costo de compra</b>
              </Col>
              {/*<Col xs={'2'}>
                <b>Costo de venta</b>
              </Col>*/}
              <Col xs={'2'}>
                <b>Total compra</b>
              </Col>
              <Col xs={'1'}>
                <b>Opciones</b>
              </Col>
            </Row>

            <hr />

            { this.makeItemsEntradasAlmacen() }

          </Col>

        </Row>

      </div>

    )
  }

  makeViewVentas() {
    let { arrStock, valSeach, } = this.state
    valSeach = valSeach.trim()

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', margin: 10, color: '#444', textAlign: 'center', width: '100%', }}>Almacenes</p>
            </Row>

            <hr />
            <Row>

              <Col>
                <Select
                  placeholder="BELLAVISTA"
                  options={this.props.subState.arrSucursales}
                  onChange={(val) => { this.setState({id_sucursal_option: val.id_sucursal}, this.getStockAlmacen) }}
                  styles={customStylesOption}
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <input
                      type={'date'}
                      value={ this.state.dateAlmacen }
                      onChange={(e) => { this.setState({ dateAlmacen: e.target.value }) }}
                      className={'regVentaPage__input_date'}
                    />
                  </Col>
                  <Col>
                    <p className={'btn btn-primary'} onClick={() => { this.getStockAlmacen() }}>Generar</p>
                  </Col>
                </Row>
              </Col>

            </Row>

            <hr />

            {
              arrStock.map((t,e) => (
                <>
                {
                  t.list.length > 0 ? (
                    <div className={'ws__list_categorias_almacen'}>
                      <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t,e) }}>
                        <Col>
                          <p>{t.nombre}</p>
                        </Col>
                        <Col>
                          <p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p>
                        </Col>
                      </Row>

                      {
                        t.show ? (
                          <div className={'ws__searchcnt'}>
                            <p>Buscar</p>
                            <input
                              type={'text'}
                              onChange={ (event) => { this.setState({ valSeach: event.target.value }) } }
                              placeholder={'Buscar un producto...'}
                            />

                            {
                              this.state.id_sucursal_option === "almacen_gral" &&
                                <button onClick={ () => {
                                  this.reinicioMasivoProductosAlmacen(t.list)
                                }} type="button" class="btn btn-danger ws_button2 w_b_2 wb-0 pt-2 pb-2">Reiniciar cantidades marcadas</button>
                            }

                          </div>
                        ) : null
                      }
                      {
                        t.show ? (
                        <Row>
                          <Col xs={'4'}>
                            <b>Nombre</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Existencia</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Entrada del día</b>
                          </Col>
                          <Col xs={'1'}>
                            <b>Merma</b>
                          </Col>
                          <Col xs={'1'}>
                            <b>Traspaso</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Vendida</b>
                          </Col>
                        </Row>
                        ) : null
                      }

                      {
                        t.show && t.list.map((t0,e0) => (
                          <>
                          {
                            valSeach === '' || 
                            t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                            t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                            <Row className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                              <Col xs={'4'}>
                                <p>{t0.nombre}</p>
                                <p>{t0.clave}</p>
                                {
                                  this.state.id_sucursal_option === "almacen_gral" &&
                                  <button onClick={ () => {
                                    arrStock[e].list[e0].reiniciarCantidad = !t0.reiniciarCantidad
                                    this.setState({
                                      arrStock
                                    })
                                  }} type="button" class={`btn btn-${t0.reiniciarCantidad ? 'danger' : 'secondary'} ws_button2 w_b_2 wb-0 pt-2 pb-2`}>{ t0.reiniciarCantidad ? 'Cancelar reinicio' : 'Elegir para reiniciar' }</button>
                                }
                              </Col>
                              <Col xs={'2'}>
                                <p>{this.number_format(t0.disponible, 2)}</p>
                              </Col>
                              <Col xs={'2'}>
                                <p>{this.number_format(t0.cantidad_dia, 2)}</p>
                              </Col>
                              <Col xs={'1'}>
                                <p>{this.number_format(t0.cantidad_merma, 2)}</p>
                              </Col>
                              <Col xs={'1'}>
                                <p>{this.number_format(t0.cantidad_traspaso, 2)}</p>
                              </Col>
                              <Col xs={'2'}>
                                <p>{t0.cantidad_vendida}</p>
                              </Col>
                            </Row>
                            ) : null
                          }
                          </>
                        ))
                      }

                    </div>
                  ) : null
                }
                </>
              ))
            }

          </Col>

        </Row>

      </div>

    )
  }

  reinicioMasivoProductosAlmacen(lista) {
    const arrProductosReinicio = []
    for(var a in lista) {

      if(lista[a].reiniciarCantidad) {
        arrProductosReinicio.push({
          id_producto: lista[a].id_producto,
          costo: lista[a].precio_compra,
          cantidad: lista[a].disponible * -1,
        })
      }

      if(a == (lista.length - 1)) {

        const data = {
          id_vendedor: 'bv_control',
          id_sucursal: 'almacen_gral',
          arrItemsAlmacen: arrProductosReinicio,
          fecha_entrada_almacen: moment().format('YYYY-MM-DD'),
          serie_almacen: 'Reinicio desde Altas -> ver almacenes',
          referencia_almacen: 'Reinicio desde Altas -> ver almacenes',
        }

        if (window.confirm(`¿Estás seguro que deseas realizar los reinicios de estos productos? ESTA ACCIÓN NO SE PUEDE DESHACER Y SE NOTIFICARÁ AL SR GALDINO`)) {
          fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterEntradaAlmacen", this.headersPOST({...data}))
          .then(response => response.json())
          .then((response) => {
            alert('¡Reinicios realizados con éxito!')
            this.getStockAlmacen()

          }).catch((error) => console.info(error));
        }

      }

    }

  }

  onVerifySectionShowCate(response) {
    let { arrStock, } = this.state
    let index = -1
    for(var a in arrStock) {
      if(arrStock[a].show) {
        index = a
        break
      }
    }
    
    if(index > -1)
      response[a].show = true
    return response
  }
  
  onExpandSectionCate(t,e) {
    let { arrStock, } = this.state
    for(var a in arrStock) {
      if(a != e)
        arrStock[a].show = false
      else
      arrStock[a].show = !arrStock[a].show
    }
    this.setState({ arrStock, valSeach: '', })
  }

  makeItemsEntradasAlmacen() {
    const { arrProductosByTraspaso, arrayListProductos, } = this.props.subState
    let cantidadTotal = 0, cantidadKGTotal = 0
    arrProductosByTraspaso.map((t) => {
      // if(!t.cantidad)
      //   t.cantidad = 0
      cantidadKGTotal = (parseFloat(t.cantidad) + cantidadKGTotal)
      cantidadTotal += ( parseFloat(t.costo_compra) * parseFloat(t.cantidad) )
    })

    //Show item new
    return (

      <>
        {
          arrProductosByTraspaso.map((t,e) => (
            <Row>
              <Col xs={'3'}>
                <b>{t.nombre || t.producto}</b>
              </Col>
              <Col xs={'3'}>
                <input type={'number'}
                  onChange={ (event) => {
                    arrProductosByTraspaso[e].cantidad = event.target.value;
                    this.props.subSetState({ arrProductosByTraspaso });
                  }}
                  value={ t.cantidad }
                  placeholder={'Ingresa la cantidad a enviar'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                  ref={(input) => { this[`inputEntradaID${e}`] = input;  }}
                />
              </Col>
              <Col xs={'3'}>
                <input type={'number'}
                  onChange={ (event) => {
                    arrProductosByTraspaso[e].costo_compra = event.target.value;
                    this.props.subSetState({ arrProductosByTraspaso });
                  }}
                  value={ t.costo_compra }
                  placeholder={'Ingresa el costo de compra'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              {/*
              <Col xs={'2'}>
                <input type={'number'}
                  onChange={ (event) => {
                    arrProductosByTraspaso[e].costo_venta = event.target.value;
                    this.props.subSetState({ arrProductosByTraspaso });
                  }}
                  value={ t.costo_venta }
                  placeholder={'Ingresa el costo de venta'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
                */}
              <Col xs={'2'}>
                <p> ${ this.number_format((t.cantidad * t.costo_compra), 2) } </p>
              </Col>
              <Col xs={'1'}>
                <p
                  style={{ cursor: 'pointer', color: 'red', fontWeight: '800', }}
                  onClick={() => {
                    const arr = arrProductosByTraspaso.filter(function(item, index) { return index !== e })
                    this.props.subSetState({ arrProductosByTraspaso: arr })
                  }}
                >X</p>
              </Col>
            </Row>
          ))
        }

        {
          arrProductosByTraspaso.length > 0
          ? (
            <div style={{ textAlign: 'right', }}>
              <p>KG: {this.number_format(cantidadKGTotal, 2)}</p>
              <p>Total: ${this.number_format(cantidadTotal, 2)}</p>

              <button
                className={'btn btn-secondary'}
                onClick={() => { this.onRegisterEntradaAlmacen() }}
              >Registrar traspaso</button>
            </div>
          ) : null
        }

        <hr />
        
        {
          /*
          [[FUNCIÓN DESHABILITADA]]
          ESTA FUNCIÓN PERMITE EL MODAL DE TRASPASOS CONECTANDO CON EXISTENCIAS
          DE PRODUCTOS DE ALMACEN GENERAL.
          arrayListProductos.length > 0 ? (
            <Row style={{ marginTop: 20, }}>
              <Col xs={'12'} style={{ cursor: 'pointer', }}
                onClick={ () => { this.props.subSetState({ isOpenSearchProductoByEntradaGral: true, arrProductoSelectedByEntradaGral: {}, }) }}
                >
                <p>Elige un producto para agregar a la lista</p>
              </Col>
            </Row>
          ) : null
          */
        }

        {
          arrayListProductos.length > 0 ? (
            <Row style={{ marginTop: 20, }}>
              <Col xs={'4'} style={{ cursor: 'pointer', }}
                onClick={ () => { this.setBindProductos() }}
                >
                {/*<p>Elige un producto para agregar a la lista</p>*/}
                <p>Ingresa el código del producto a enviar</p>
              </Col>
              <Col xs={'6'}>
                <input
                  type="text"
                  id={'ws-input-search-code'}
                  autoComplete="off"
                  placeholder="Ingresa el código del producto..."
                  value={this.state.valSearchByFullCode}
                  onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                  onKeyDown={this._handleKeyDown}
                  ref={(input) => { this.inputSearchByCode = input;  }}
                  style={{ margin: '20px auto', marginTop: 0, width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                />
              </Col>
            </Row>
          ) : null
        }

      </>
    )
  }

  setBindProductos() {
    this.setState({isOpenSearchProducto: true})
    setTimeout(() => {
      this.inputSearchProducto.focus(); 
    }, 100)
  }

  onViewProduct(val) {
    let { arrayListProductos } = this.props.subState

    this.setState({ valSearch: val })
    let countLimit = 0

    arrayListProductos = arrayListProductos.filter(function(producto, index) {
      if(countLimit <= 30) {
        if(typeof producto.nombre === 'undefined' || !producto.nombre) {
        } else {
          if(producto.nombre.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
            countLimit++
            return true
          }
        }
      }
    });
    this.setState({ arrayListResults: arrayListProductos });
  }

  selectItemProduct(e) {
    let { arrListVenta, arrayListResults, } = this.state
    let { arrProductosByTraspaso, } = this.props.subState
    const { signedIn } = this.props.initState
    const t = arrayListResults[e]
    let codigo = '', producto = ''

    if( t.nombre.indexOf(' - ') !== -1) {
      //Tiene código (separar)
      const sep = t.nombre.split(' - ')
      codigo = sep[0]
      producto = sep[1]
    } else
    producto = t.nombre;

    let newItem = [{
      id_producto: t.id_producto,
      codigo,
      producto,
      cantidad: '',
      costo: t.precio_compra,
      costo_compra: t.precio_compra,
    }]

    arrProductosByTraspaso = [ ...arrProductosByTraspaso, ...newItem ]

    this.props.subSetState({ arrProductosByTraspaso, })
    this.setState({
      isOpenSearchProducto: false,
      valSearch: '',
    })

    setTimeout(() => {
      const index = arrProductosByTraspaso.length - 1
      this[`inputEntradaID${(index)}`].focus();
    }, 100)
  }

  _handleKeyDown(e) {
    if(e.key === 'Enter') {
      this.onSearchProductoByCode()
    }
  }

  onSearchProductoByCode() {
    let { valSearchByFullCode, } = this.state
    let { arrayListProductos, arrProductosByTraspaso, } = this.props.subState

    if(valSearchByFullCode.trim() == '')
      return false

    let countLimit = 0
    let index = -1

    for(var a in arrayListProductos) {
      if(arrayListProductos[a].folio == valSearchByFullCode) {
        index = a
        break;
      }
    }

    if(index > -1) {
      let codigo = '', producto = ''
      let t = arrayListProductos[index]

      if( t.nombre.indexOf(' - ') !== -1) {
        //Tiene código (separar)
        const sep = t.nombre.split(' - ')
        codigo = sep[0]
        producto = sep[1]
      } else
        producto = t.nombre;

      let newItem = [{
        id_producto: t.id_producto,
        codigo,
        producto,
        cantidad: '',
        costo: t.precio_compra,
        costo_compra: t.precio_compra,
      }]
      arrProductosByTraspaso = [ ...arrProductosByTraspaso, ...newItem ]

      this.props.subSetState({ arrProductosByTraspaso, })
      this.setState({valSearchByFullCode: '',})

      setTimeout(() => {
        const index = arrProductosByTraspaso.length - 1
        this[`inputEntradaID${(index)}`].focus();
      }, 100)
    }

  }

  selectItemProductFromProcesos(e) {
    let { arrItemsAlmacen, arrayListResults } = this.props.subState
    const t = arrayListResults[e]
    let codigo = '', producto = ''

    arrayListResults = [t]
    this.props.subSetState({ arrProductoSelectedByEntradaGral: { id_producto: t.id_producto, nombre: t.nombre, }, arrayListResults: [] })
    this.getKGDispProdByProcesos(t.id_producto)

  }

  onRegisterEntradaAlmacen() {
    const { id_vendedor, } = this.props.initState
    const { arrProductosByTraspaso, arrItemsAlmacen, fecha_entrada_almacen, serie_almacen, referencia_almacen, } = this.props.subState
    const { mostrarMisVentas, id_sucursal_destino, } = this.state

    const id_sucursal = id_sucursal_destino;

    //Validamos que todos los items ya tengan cantidad y costo
    let flag = true
    for(var a in arrProductosByTraspaso) {
      if(arrProductosByTraspaso[a].cantidad == '' || arrProductosByTraspaso[a].costo_compra == '') {
        flag = false;
      }

      if( a == (arrProductosByTraspaso.length - 1) ) {
        let sucursal = ''
        this.props.subState.arrSucursales.map(t => { if(t.id_sucursal === id_sucursal) {sucursal = t.nombre}})
        
        //Registramos la entrada en la BD
        if(!flag || serie_almacen == '' || referencia_almacen == '' ) {
          alert('Por favor, registra la cantidad y el costo de cada producto.')
          return false
        } else if(window.confirm(`Confirmas que deseas enviar esta entrada al almacén de: ${sucursal}`)) {

          const data = {
            id_vendedor,
            id_sucursal,
            arrProductosByTraspaso,
            fecha_entrada_almacen,
            serie_almacen,
            referencia_almacen,
            opt: 2,
          }
          fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterTraspasoAlmacen", this.headersPOST({...data}))
          .then(response => response.json())
          .then((response) => {
            this.props.subSetState({
              arrProductosByTraspaso: [],
              serie_almacen: '',
              referencia_almacen: '',
            })
            alert('Envío realizado con éxito')
            this.props.initState.socket.emit("toCajero", { client: 'hgapp', substrace: 'setUpdateEntradasAlmacen', })
          }).catch((error) => console.info(error));

        }
      }
    }
    return false
  }

  getStockAlmacen() {
    const { dateAlmacen, id_sucursal_option, } = this.state

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", this.headersPOST({ id_sucursal: id_sucursal_option, dateAlmacen }))
    .then(response => response.json())
    .then((response) => {
      let arrStock = this.onVerifySectionShowCate(response)
      this.setState({ arrStock, })
    })
  }

  getStockAlmacenGral() {
    const { dateAlmacen, } = this.state

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getStockAlmacenGral", this.headersPOST({ dateAlmacen }))
    .then(response => response.json())
    .then((response) => {
      let arrStockGral = this.onVerifySectionShowCate(response)
      this.setState({ arrStockGral, })
    })
  }
  
  getCombosAlmacenGral() {
    const { dateAlmacen } = this.state
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getCombosAlmacenGral", this.headersPOST({  }))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ arrAlmacenGral: response.combos, arrTraspasosPendientes: response.pendientes, arrTraspasosConfirmados: response.confirmados, })
    })
  }
  
  getKGDispProdByProcesos(id_producto) {
    let { arrProcesosDisponiblesByProducto, arrProductosByTraspaso, } = this.props.subState
    let flagRegister = true;

    arrProductosByTraspaso.map((t) => {
      if(t.id_producto === id_producto) {
        flagRegister = false
      }
    })

    if(flagRegister) {
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getKGDispProdByProcesos", this.headersPOST({ id_producto, }))
      .then(response => response.json())
      .then((response) => {
        this.props.subSetState({ arrProcesosDisponiblesByProducto: response.list, isOpenSearchProductoByEntradaGral: true, })
      })
    } else {
      alert('Este producto ya lo agregaste a tu lista de traspaso, si deseas modificar la cantidad debes removerlo antes.')
      return false
    }
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


}

export default withRouter(AltasModulePage)





